<template>
  <div class="alarm-detail-box">
    <div class="box1">
      <img :src="alarmDetailData.portrait" alt="" />
      <div>
        <p>
          <label>用户</label>: <span>{{ alarmDetailData.realName }}</span>
        </p>
        <p>
          <label>报警时间</label>: <span>{{ alarmDetailData.happenDate }}</span>
        </p>
        <p>
          <label>身份证号</label>: <span>{{ alarmDetailData.idCard }}</span>
        </p>

        <p>
          <label>电话</label>: <span>{{ alarmDetailData.phone }}</span>
        </p>
        <p>
          <label>报警类型</label>: <span>{{ alarmDetailData.typeName }}</span>
        </p>
        <p>
          <label>报警地点</label>: <span>{{ alarmDetailData.address }}</span>
        </p>
      </div>
    </div>
    <Steps :timeline-list="alarmDetailData.handlers">
      <div
        v-for="(i, index) in alarmDetailData.handlers"
        style="display: inline-block"
        :key="index"
        :slot="'header' + index"
      >
        <span class="handleUserName">{{ i.userName }}</span>
        <span class="alarmType">【{{ i.handleTypeName }}】</span>
        <span class="centerName">{{ i.areaName }}</span>
      </div>
      <div
        v-for="(i, index) in alarmDetailData.handlers"
        style="display: inline-block"
        :key="index"
        :slot="'content' + index"
      >
        <div class="content">
          <p>
            <span>时间:</span><span>{{ i.createGmt }}</span>
          </p>
          <p>
            <span>地点:</span><span>{{ i.areaName }}</span>
          </p>
          <p>
            <span>内容:</span><span>{{ i.content }}</span>
          </p>
        </div>

        <div v-for="(item, index) in i.disTask" :key="index" style="margin-top: 10px">
          <p>
            <span class="handleUserName">{{ item.name }}</span
            ><span class="alarmType">【{{ item.statusName }}】</span>
          </p>
          <p>
            <span>紧急程度: </span><span>{{ item.grad }}</span>
          </p>
          <!-- <p><span>任务描述:     </span><span>{{item.resultContent}}</span></p> -->

          <div class="disTask">
            <span class="task-title">任务反馈</span>
            <div class="item-m">
                <span>内容：</span>
                <span>{{item.resultContent}}</span>
            </div>
            <div class="item-m" v-if="item.files.length != 0">
              <span>图片：</span>
              <div class="img">
                <div v-for="(citem, cindex) in item.files" :key="cindex">
                  <el-image
                    v-if="citem.fileType == 1"
                    style="width: 100px; height: 100px"
                    :src="citem.fileUrl"
                    :preview-src-list="[citem.fileUrl]"
                  ></el-image>
                </div>
              </div>
            </div>
            <div class="item-m" v-if="item.files.length != 0">
              <span>音频：</span>
              <div class="img" v-for="(citem, cindex) in item.files" :key="cindex">
                <m-audio v-if="citem.fileType == 4" :src="citem.fileUrl"></m-audio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Steps>
  </div>
</template>

<script>
export default {
  name: "alarm-detail-box",
  props: { alarmDetailData: { type: Object } },
  created() {
    console.log(this.alarmDetailData);
  },
};
</script>

<style scoped lang="less">
@import "alarm-detail-box";
.disTask{
    display: flex;
    flex-direction: column;
    .task-title{
        margin-top: 10px;
    }
    .item-m{
        display: flex;
        margin-bottom: 10px;
        span{
            // margin-right: 5px;
        }
        .img{
            display: flex;
            flex-wrap: wrap;
            .el-image{
                margin: 0 5px;
            }
        }
    }
}
</style>
